import { clavePayment } from '../constants/paymentTypes';

/**
 * Helper function to determine if given payment is handled by a third party provider
 * For now, only Clave is provided by a third party (Telered)
 */
export default function isThirdPartyPayment(paymentType: string): boolean {
  return paymentType === clavePayment;
}
